import { Tooltip } from '@blueprintjs/core';
import { useMemo } from 'react';

type ConditonalTooltipProps = React.PropsWithChildren<{
  conditions: Array<{
    isTooltipVisible: boolean;
    tooltipContent: string | React.JSX.Element;
    isChildDisabled?: boolean;
  }>;
  render?: (disabled: boolean) => string | React.JSX.Element;
}>;

export const ConditionalTooltip: React.FC<ConditonalTooltipProps> = ({
  conditions,
  children,
  render,
}) => {
  const conditional = useMemo(
    () => conditions.find((x) => x.isTooltipVisible),
    [conditions],
  );

  return (
    <Tooltip
      placement="top"
      disabled={!conditional?.isTooltipVisible}
      content={conditional?.tooltipContent}
    >
      {children ||
        (render ? render(conditional?.isChildDisabled ?? false) : null)}
    </Tooltip>
  );
};
